import { FormControl, FormLabel, Grid, RadioGroup, Radio, Box } from '@mui/joy'
import { Controller } from 'react-hook-form'
import { NumericInput } from '../NumericInput'

type DetailsInputProps = {
  name: string
  label?: string
  readOnly?: boolean
  skeletonShow?: boolean
}

type DiscountType = 'percent' | 'amount'

export function DetailsInput({
  label,
  name,
  readOnly,
  skeletonShow,
}: DetailsInputProps) {
  return (
    <Controller
      name={name}
      render={({ field: { onChange, value } }) => {
        const details = value || {}

        const hasValidAmount =
          details.discount_amount !== undefined &&
          details.discount_amount !== null &&
          !isNaN(details.discount_amount) &&
          details.discount_amount > 0

        const hasValidPercent =
          details.discount_percent !== undefined &&
          details.discount_percent !== null &&
          !isNaN(details.discount_percent) &&
          details.discount_percent > 0

        const currentDiscountType: DiscountType = hasValidAmount
          ? 'amount'
          : hasValidPercent
          ? 'percent'
          : (details._discountType as DiscountType) || 'percent'

        const handleDiscountTypeChange = (newType: DiscountType) => {
          if (newType === 'percent') {
            onChange({
              ...details,
              _discountType: 'percent', // Сохраняем выбранный тип
              discount_percent: undefined,
              discount_amount: undefined,
            })
          } else {
            onChange({
              ...details,
              _discountType: 'amount', // Сохраняем выбранный тип
              discount_percent: undefined,
              discount_amount: undefined,
            })
          }
        }

        return (
          <FormControl component={Grid} xs={12}>
            {label && <FormLabel>{label}</FormLabel>}

            <Box sx={{ mt: 1 }}>
              <RadioGroup
                value={currentDiscountType}
                onChange={(e) =>
                  handleDiscountTypeChange(e.target.value as DiscountType)
                }
                sx={{ mb: 2 }}
              >
                <Radio
                  value='percent'
                  label='Процент скидки'
                  disabled={readOnly}
                />
                <Radio
                  value='amount'
                  label='Сумма скидки'
                  disabled={readOnly}
                />
              </RadioGroup>

              <Grid container spacing={2}>
                {currentDiscountType === 'percent' && (
                  <Grid xs={6}>
                    <NumericInput
                      name={`${name}.discount_percent`}
                      label='Процент скидки (%)'
                      placeholder='0-100'
                      readOnly={readOnly}
                      skeletonShow={skeletonShow}
                    />
                  </Grid>
                )}

                {currentDiscountType === 'amount' && (
                  <Grid xs={6}>
                    <NumericInput
                      name={`${name}.discount_amount`}
                      label='Сумма скидки'
                      placeholder='Сумма'
                      readOnly={readOnly}
                      skeletonShow={skeletonShow}
                    />
                  </Grid>
                )}

                <Grid xs={6}>
                  <NumericInput
                    name={`${name}.duration_days`}
                    label='Количество дней действия скидки'
                    placeholder='Дней'
                    readOnly={readOnly}
                    skeletonShow={skeletonShow}
                  />
                </Grid>
              </Grid>
            </Box>
          </FormControl>
        )
      }}
    />
  )
}
